@if (!isPluginMode()) {
  <mat-toolbar class="header">
    <div class="back" mat-dialog-close matTooltip="Atrás" matTooltipPosition="right">
      <mat-icon >arrow_back_ios_new</mat-icon>
    </div>
    <div>
      Crear Documento
    </div>
  </mat-toolbar>
}

<div [ngClass]="{'dialog-wrapper': !isPluginMode()}">
  <div #wrapper>
    <form [formGroup]="form" class="form">
      <section>
        @if(!isPluginMode() && _enableDocumentSelection()) {
          <div class="form-row">
            <mat-checkbox
              [(ngModel)]="createFromDocumentMode"
              [ngModelOptions]="{standalone: true}"
              (ngModelChange)="toggleCreateFromDocumentMode($event)"
            > Crear a partir de un documento
            </mat-checkbox> 
          </div>
          @if (createFromDocumentMode()) {
            <div class="form-row">
              <mat-form-field class="field">
                <mat-label>Tipo de Documento Origen</mat-label>
                <mat-select formControlName="document_type">
                  @for (sourceDocumentType of SOURCE_DOCUMENT_TYPES; track sourceDocumentType) {
                    <mat-option [value]="sourceDocumentType">
                      {{ sourceDocumentType | human }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (form.get('document_type').value) {
                <app-document-select
                  formControlName="document_id"
                  [documentType]="form.get('document_type').value"
                  (onload)="onDocumentLoad($event)"
                  prefix="#"
                >
                </app-document-select>
              }
            </div>
          }
        }
  
        <div class="form-row">
          <mat-form-field class="field">
            <mat-label>Tipo de Documento de Facturación a crear</mat-label>
            <mat-select formControlName="invoice_type">
              @for (invoiceType of invoiceTypes; track invoiceType){
                <mat-option value="{{invoiceType}}">
                  {{invoiceType | human | titlecase }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </section>

      @if (form.get('invoice_type').value) {
        <section>
          <div class="subtitle">Cliente</div>
          <div class="form-row">
            <mat-form-field class="field">
              <mat-label>Tipo de Cliente</mat-label>
              <mat-select formControlName="stakeholder_type">
                <mat-option value="Client">{{'client' | human}}</mat-option>
                <mat-option value="Provider">{{ 'provider' | human }}</mat-option>
              </mat-select>
            </mat-form-field>
            @if (form.get("stakeholder_type").value) {
              @switch (form.get("stakeholder_type").value) {
                @case('Client') {
                  <app-client-select
                    formControlName="stakeholder_id"
                    (onload)="onClientLoad($event)"
                  >
                  </app-client-select>
                }
                @case('Provider') {
                  <app-provider-select
                    formControlName="stakeholder_id"
                    (onload)="onClientLoad($event)"
                  >
                  </app-provider-select>
                }
              }
            }

            <mat-form-field class="field">
              <mat-label>Razon Social</mat-label>
              <input matInput [formControl]="form.get('data.client.company') | formGroup" />
            </mat-form-field>
            
            <mat-form-field class="field">
              <mat-label>Giro</mat-label>
              <input matInput [formControl]="form.get('data.client.activity') | formGroup">
            </mat-form-field>
          </div>

          @if (selectedClient()) {
            <ng-container formGroupName="data">
              <div>
                <p class="subtitle">Seleccione una dirección de facturación</p>
                <app-billing-info-form
                  [entity_type]="form.get('stakeholder_type').value"
                  [entity]="selectedClient()"
                  [selectionMode]="true"
                  formControlName="billing_info"
                >
                </app-billing-info-form>
              </div>
            </ng-container>
            <br />
          }
        </section>

        <div>
          <p class="subtitle">Detalle</p>
          <app-invoice-details-form
            [formArray]="form.get('data.details') | formGroup"
            [original]="originalDetails()" 
          >
          </app-invoice-details-form>
        </div>
      }

      @defer (when selectedClient()) {
        <section>
          <p class="subtitle">Detalle de Pago</p>
          <app-allocations-form
            [formArray]="form.get('data.allocations_attributes') | formGroup"
            [activePrepayments]="selectedClient()?.active_prepayments"
            [totalAmountToPay]="total"
            [party]="selectedClient()"
          >
          </app-allocations-form>
        </section>
  
        <section>
          <div class="form-row">
            <div class="note-input">
              <mat-form-field appearance="fill">
                <mat-label>Nota</mat-label>
                <textarea matInput [formControl]="form.get('data.note') | formGroup"></textarea>
              </mat-form-field>
            </div>
            <ng-container formGroupName="data">
              <mat-checkbox formControlName="declare_to_sii">
                Enviar documento al Sii para validación
              </mat-checkbox>
            </ng-container>
          </div>
        </section>
      }
    </form>
  </div>
</div>

@if (!isPluginMode()) {
  <mat-toolbar class="footer">
    <button mat-raised-button mat-dialog-close> 
      Cancelar
    </button>
    <div class="expander"></div>
    <button mat-raised-button
            type="button"
            color="primary"
            [disabled]="!formValid || loading()"
            (click)="saveForm()">
      @if (loading()) {
        <mat-spinner diameter="30"></mat-spinner>
      } @else {
        Crear/Iniciar
      }
    </button>
  </mat-toolbar>
}
